import React from 'react'

const ClientsReviewsSlider = () => {
  return (
    <div>Clients Reviews Slider</div>
  )
}

export default ClientsReviewsSlider